import { api } from '../lib/api';

export interface Customer {
  id: number;
  name: string;
  customerTypeItemId: number | null;
  customerTypeLabel?: string | null;
  isCompany: number | null;
  orgNr: string | null;
  vatNr: string | null;
  fortnoxCustomerNumber: string | null;
  email: string | null;
  phone: string | null;
  website: string | null;
  contactPerson: string | null;
  invoiceAddress1: string | null;
  invoiceAddress2: string | null;
  invoicePostalCode: string | null;
  invoiceCity: string | null;
  invoiceCountry: string | null;
  deliveryAddress1: string | null;
  deliveryAddress2: string | null;
  deliveryPostalCode: string | null;
  deliveryCity: string | null;
  deliveryCountry: string | null;
  notes: string | null;
  isActive: number;
}

export interface CustomerFormData {
  name: string;
  customerTypeItemId?: number | null;
  isCompany?: boolean | null;
  orgNr?: string;
  vatNr?: string;
  fortnoxCustomerNumber?: string;
  email?: string;
  phone?: string;
  website?: string;
  contactPerson?: string;
  invoiceAddress1?: string;
  invoiceAddress2?: string;
  invoicePostalCode?: string;
  invoiceCity?: string;
  invoiceCountry?: string;
  deliveryAddress1?: string;
  deliveryAddress2?: string;
  deliveryPostalCode?: string;
  deliveryCity?: string;
  deliveryCountry?: string;
  notes?: string;
  isActive?: boolean;
}

export interface CustomersMeta {
  customerTypes: Array<{ id: number; label: string }>;
}

export const customersApi = {
  list: () => api.get<{ customers: Customer[] }>('/customers'),
  meta: () => api.get<CustomersMeta>('/customers/meta'),
  get: (id: number) => api.get<Customer>(`/customers/${id}`),
  create: (data: CustomerFormData) => api.post<{ id: number; name: string }>('/customers', data),
  update: (id: number, data: CustomerFormData) => api.patch<{ ok: boolean }>(`/customers/${id}`, data),
  delete: (id: number) => api.delete<{ ok: boolean }>(`/customers/${id}`),
};
